
import { z } from 'zod';

// Plan caps on non-archived, non-discarded listings. Free applies once the trial expires
// with no live subscription; Standard while in good standing. Enterprise groups get a
// per-group override column instead of a constant.
export const FREE_MAX_ACTIVE_LISTINGS = 3;
export const STANDARD_MAX_ACTIVE_LISTINGS = 15;

// Support-set per-group override bounds; shared so the internal route and its client
// control can't drift.
export const LISTING_CAP_OVERRIDE_MIN = 1;
export const LISTING_CAP_OVERRIDE_MAX = 1000;

export const SetListingCapInputSchema = z.object({
  maxActiveListings: z
    .number()
    .int()
    .min(LISTING_CAP_OVERRIDE_MIN)
    .max(LISTING_CAP_OVERRIDE_MAX)
    .nullable(),
});

// Stable across sandbox and live mode by design — the server resolves real price ids
// from these at checkout time.
export const PRICE_LOOKUP_KEYS = {
  monthly: 'standard_monthly',
  yearly: 'standard_yearly',
} as const;

export type BillingInterval = keyof typeof PRICE_LOOKUP_KEYS;

// Statuses the Customer Portal can't revive — only a fresh Checkout gets the group back.
// Every OTHER non-null status means a live (or portal-fixable) subscription, where a second
// Checkout would double-subscribe. The client's plan tiles and the server's
// already-subscribed guard both key off this one set.
export const DEAD_SUBSCRIPTION_STATUSES: readonly string[] = [
  'canceled',
  'unpaid',
  'incomplete_expired',
];
